import {
  CLINICAL_NOTES_MASTER_KEY_LENGTH,
  CLINICAL_NOTES_MASTER_KEY_STORAGE_KEY
} from '@/config/constants'
import { base64UrlToBytes, bytesToBase64Url } from '@/modules/psychology/clinical-notes/utils/base64url'

export function persistClinicalNotesMasterKey(masterKeyBytes) {
  if (!masterKeyBytes || masterKeyBytes.length !== CLINICAL_NOTES_MASTER_KEY_LENGTH) {
    return false
  }
  try {
    localStorage.setItem(CLINICAL_NOTES_MASTER_KEY_STORAGE_KEY, bytesToBase64Url(masterKeyBytes))
    return true
  } catch (_) {
    return false
  }
}

export function loadClinicalNotesMasterKey() {
  const bytes = base64UrlToBytes(localStorage.getItem(CLINICAL_NOTES_MASTER_KEY_STORAGE_KEY))
  if (!bytes || bytes.length !== CLINICAL_NOTES_MASTER_KEY_LENGTH) return null
  return bytes
}
